/**
 * Determines the selected key based on user group permissions
 * @param {Array} userGroup - Array of user group names
 * @returns {string} The selected key based on user group
 */
export const getSelectedKeyFromUserGroup = (userGroup) => {
  if (!userGroup || userGroup.length === 0) return '3';

  if (
    userGroup.includes('web-page') ||
    userGroup.includes('web-page-without-create-project') ||
    userGroup.includes('super-admin')
  ) {
    return '1';
  }

  if (userGroup.includes('admin')) {
    return '4';
  }

  if (
    userGroup.some((group) =>
      ['heat-profile', 'coating-record-db', 'dcal-generator'].includes(group)
    )
  ) {
    return '5';
  }

  if (userGroup.includes('analysis')) {
    return '2';
  }

  return '3';
};
